'use client';

import React, { useState } from 'react';
import { Mail, X, Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { resendVerification } from '@/lib/api-client';

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.emailVerified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await resendVerification();
      setSent(true);
    } catch { /* ignore */ } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/20 px-4 py-2.5">
      <div className="max-w-screen-2xl mx-auto flex items-center gap-3">
        <Mail size={14} className="text-amber-400 flex-shrink-0" />
        <p className="text-xs text-amber-300 flex-1">
          Please verify your email address to unlock all features.
          {!sent && (
            <>
              {' '}
              <button
                onClick={handleResend}
                disabled={sending}
                className="underline hover:text-amber-200 transition-colors inline-flex items-center gap-1"
              >
                {sending && <Loader2 size={10} className="animate-spin" />}
                {sending ? 'Sending…' : 'Resend verification email'}
              </button>
            </>
          )}
          {sent && ' Check your inbox!'}
        </p>
        <button onClick={() => setDismissed(true)} className="text-amber-500 hover:text-amber-300 transition-colors flex-shrink-0">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
